import { Button } from "@/shared/components/ui/button";
import { Badge } from "@/shared/components/ui/badge";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/shared/components/ui/dialog";
import { getVoiceCallStatusColor } from "@/modules/hrPortal/utils/voiceCallHelpers";
import type { VoiceCallLog } from "@/modules/hrPortal/types";
import InterestStars from "@/modules/hrPortal/components/shared/InterestStars";

interface VoiceCallDetailsDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  selectedCallLog: VoiceCallLog | null;
}

export default function VoiceCallDetailsDialog({
  open,
  onOpenChange,
  selectedCallLog,
}: VoiceCallDetailsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Voice Call Details</DialogTitle>
          <DialogDescription>
            Call log and transcript information
          </DialogDescription>
        </DialogHeader>

        {selectedCallLog && (
          <div className="space-y-4">
            <div className="grid grid-cols-1 gap-4 md:grid-cols-3">
              <div className="rounded-lg bg-slate-50 p-3">
                <p className="text-xs text-muted-foreground">Candidate</p>
                <p className="font-medium">{selectedCallLog.candidateName}</p>
              </div>

              <div className="rounded-lg bg-slate-50 p-3">
                <p className="text-xs text-muted-foreground">Status</p>
                <Badge
                  variant="secondary"
                  className={getVoiceCallStatusColor(
                    selectedCallLog.status ?? ""
                  )}
                >
                  {selectedCallLog.status}
                </Badge>
              </div>

              <div className="rounded-lg bg-slate-50 p-3">
                <p className="text-xs text-muted-foreground">Duration</p>
                <p className="font-medium">{selectedCallLog.duration}</p>
              </div>
            </div>

            <div>
              <p className="mb-2 text-sm font-medium">Interest Level</p>
              <div className="flex items-center gap-1 text-lg">
                <InterestStars level={selectedCallLog.interestLevel ?? 0} />
              </div>
            </div>

            <div>
              <p className="mb-2 text-sm font-medium">Key Insights</p>
              <div className="flex flex-wrap gap-2">
                {(selectedCallLog.insights || []).map((insight, index) => (
                  <Badge
                    key={`${selectedCallLog.id}-insight-${index}`}
                    variant="outline"
                  >
                    {insight}
                  </Badge>
                ))}
              </div>
            </div>
          </div>
        )}

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
